export function clearAuthCache() {
  try {
    sessionStorage.clear();
    localStorage.clear();
  } catch {
    // ignore quota / private-mode failures
  }
}

export async function hardSignOut(signOut) {
  try {
    await signOut();
  } catch {
    // still wipe local state
  }
  clearAuthCache();
  window.location.replace("/login");
}
